import Notification, { EventSamplePoint, NotificationEventType, SamplePointEvent } from 'types/models/notification';

import { getNotificationEventType } from './notification-event-type';

export function assertIsSamplePointNotification(n: Notification): asserts n is Notification<SamplePointEvent> {
  if (n.eventType !== NotificationEventType.SAMPLE_POINT_EVENT) {
    throw new Error('Notification is not for a SamplePointEvent');
  }
};

export const getEventSamplePointFromNotification = (
  notification: Notification | null | undefined
): EventSamplePoint | null => {
  if (!notification) return null;

  if (getNotificationEventType(notification.event) === NotificationEventType.SAMPLE_POINT_EVENT) {
    const event = notification.event as SamplePointEvent;
    return event.samplePoint;
  }

  return null;
};